import request from './request'

export function login(data) {
  return request.post('/auth/login', data)
}

export function searchLoginTenants(keyword, limit = 15) {
  return request.get('/auth/tenants/search', { params: { keyword, limit } })
}

export function sendSms(phone, scene = 'register') {
  return request.post('/auth/sms/send', { phone, scene })
}

export function register(data) {
  return request.post('/auth/register', data)
}

export function resetPassword(data) {
  return request.post('/auth/password/reset', data)
}

export function changePassword(data) {
  return request.post('/auth/password/change', data)
}

export function updateProfile(data) {
  return request.post('/auth/profile', data)
}

export function fetchMe() {
  return request.get('/auth/me')
}

export function fetchNav() {
  return request.get('/platform/menus/nav')
}

export function fetchButtonPerms() {
  return request.get('/platform/menus/button-perms')
}

export function fetchOverview() {
  return request.get('/platform/overview')
}
